import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
   Dialog,
   DialogContent,
   DialogDescription,
   DialogFooter,
   DialogHeader,
   DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ScrollArea } from "@/components/ui/scroll-area";
import React, { useEffect, useState } from 'react';
import { toast } from "sonner";

const COVPresetModal = ({ isOpen, onClose, onSave, initialPreset }) => {
   const defaultSelectedDocuments = {
      letterOfIntent: true,
      tallySheet: true,
      driverLicense: true,
      forestCertification: true,
      orCr: true,
      specialPowerOfAttorney: false
   };

   const [preset, setPreset] = useState({
      name: '',
      address: '',
      cellphone: '',
      purpose: '',
      driverName: '',
      driverAddress: '',
      driverLicenseNumber: '',
      vehiclePlateNumber: '',
      originAddress: '',
      destinationAddress: '',
      selectedDocuments: defaultSelectedDocuments
   });

   useEffect(() => {
      if (initialPreset) {
         setPreset({
            ...initialPreset,
            selectedDocuments: {
               ...defaultSelectedDocuments,
               ...(initialPreset.selectedDocuments || {})
            }
         });
      }
   }, [initialPreset]);

   const renderFileRequirements = () => {
      const fileTypes = [
         { type: 'letterOfIntent', label: 'Letter of Intent', path: 'letter-of-intent.jpg' },
         { type: 'tallySheet', label: 'Tally Sheet', path: 'tally-sample.png' },
         { type: 'driverLicense', label: 'Driver License', path: 'driver-license.jpg' },
         { type: 'forestCertification', label: 'Forest Certification', path: 'forest-certification.png' },
         { type: 'orCr', label: 'OR/CR', path: 'or-cr.jpg' },
         { type: 'specialPowerOfAttorney', label: 'Special Power of Attorney', path: 'Special-Power-of-Attorney.png' }
      ];

      return fileTypes.map(({ type, label }) => (
         <div key={type} className="flex items-center space-x-2 mb-4">
            <Checkbox
               id={type}
               checked={preset.selectedDocuments[type]}
               onCheckedChange={(checked) => {
                  setPreset(prev => ({
                     ...prev,
                     selectedDocuments: {
                        ...prev.selectedDocuments,
                        [type]: checked
                     }
                  }));
               }}
            />
            <div>
               <Label htmlFor={type} className="text-sm text-muted-foreground">{label}</Label>
               <div className="mt-1 text-xs text-gray-500">
                  {type === 'specialPowerOfAttorney' ? 'Optional' : 'Required'}
               </div>
            </div>
         </div>
      ));
   };

   const handleSave = () => {
      localStorage.setItem('covPreset', JSON.stringify(preset));
      onSave(preset);
      toast.success('COV preset saved successfully');
      onClose();
   };

   return (
      <Dialog open={isOpen} onOpenChange={onClose}>
         <DialogContent className="max-w-[600px] max-h-[80vh]">
            <DialogHeader>
               <DialogTitle>Edit COV Application Preset</DialogTitle>
               <DialogDescription>
                  Configure default values for test COV applications
               </DialogDescription>
            </DialogHeader>

            <ScrollArea className="h-[500px] pr-4">
               <div className="space-y-4 pb-4">
                  {/* <div>
                     <Label>Full Name</Label>
                     <Input
                        value={preset.name}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, name: e.target.value }))
                        }
                        placeholder="Enter full name"
                     />
                  </div>

                  <div>
                     <Label>Address</Label>
                     <Input
                        value={preset.address}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, address: e.target.value }))
                        }
                        placeholder="Enter address"
                     />
                  </div>

                  <div>
                     <Label>Contact Number</Label>
                     <Input
                        value={preset.cellphone}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, cellphone: e.target.value }))
                        }
                        placeholder="Enter contact number"
                     />
                  </div>

                  <div>
                     <Label>Purpose</Label>
                     <Textarea
                        value={preset.purpose}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, purpose: e.target.value }))
                        }
                        placeholder="Enter purpose"
                     />
                  </div>

                  <div>
                     <Label>Driver Name</Label>
                     <Input
                        value={preset.driverName}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, driverName: e.target.value }))
                        }
                        placeholder="Enter driver name"
                     />
                  </div>

                  <div>
                     <Label>Driver License Number</Label>
                     <Input
                        value={preset.driverLicenseNumber}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, driverLicenseNumber: e.target.value }))
                        }
                        placeholder="Enter license number"
                     />
                  </div>

                  <div>
                     <Label>Vehicle Plate Number</Label>
                     <Input
                        value={preset.vehiclePlateNumber}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, vehiclePlateNumber: e.target.value }))
                        }
                        placeholder="Enter plate number"
                     />
                  </div>

                  <div>
                     <Label>Origin Address</Label>
                     <Input
                        value={preset.originAddress}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, originAddress: e.target.value }))
                        }
                        placeholder="Enter origin address"
                     />
                  </div>

                  <div>
                     <Label>Destination Address</Label>
                     <Input
                        value={preset.destinationAddress}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, destinationAddress: e.target.value }))
                        }
                        placeholder="Enter destination address"
                     />
                  </div> */}
{/* 
                  <div>
                     <Label>Driver Address</Label>
                     <Input
                        value={preset.driverAddress}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, driverAddress: e.target.value }))
                        }
                        placeholder="Enter driver address"
                     />
                  </div> */}

                  <div className="border-t border-gray-200 pt-4 mt-4">
                     <h3 className="text-lg font-semibold mb-4">Required Documents</h3>
                     {renderFileRequirements()}
                  </div>
               </div>
            </ScrollArea>

            <DialogFooter>
               <Button variant="outline" onClick={onClose}>
                  Cancel
               </Button>
               <Button onClick={handleSave}>Save Preset</Button>
            </DialogFooter>
         </DialogContent>
      </Dialog>
   );
};

export default COVPresetModal;